const initialState = {
  fleetId: null,
  fleet: null,
  devices: [],
};

export default function otaUpdatesReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_OTA_FLEET": {
      state = {
        ...state,
        fleet: action.payload,
      };
      return state;
    }
    case "SET_OTA_DEVICES": {
      state = {
        ...state,
        devices: action.payload,
      };
      return state;
    }
    default:
      return state;
  }
}
